import { Box } from '@mui/material';
import { IPerformanceSummaryTableProps } from 'models/loan-projection/performance-summary';
import CapitalStructure from './capital-structure';
import LiquidityRatio from './liquidity-ratio';
import { FormTitle } from 'components/common/form-components/FormTitle';
import SimpleFormLabel from 'components/common/form-components/form-label';
import { getFormFields } from 'utils/form-utils';
import { MULTI_LINE_INPUT } from 'constants/form-components';
import { useLocation } from 'react-router-dom';

interface IProps extends IPerformanceSummaryTableProps {
  liquidityData: any;
  capitalStructureData: any;
}

export default function LiquidityRatioAndCapitalStructure(props: IProps) {
  const { t, liquidityData, capitalStructureData } = props;
  const { state } = useLocation();
  return (
    <>
      <Box sx={{ pl: 0.5, pr: 0.5 }}>
        <FormTitle title={t('loanProjection.performanceSummary.liquidityRatioAndCapitalStructure')} />
        <Box sx={{ mt: 0.5 }}>
          <LiquidityRatio {...props} data={liquidityData} />
          <CapitalStructure data={capitalStructureData} {...props} />
          <Box sx={{ display: 'flex', mt: 2 }}>
            <SimpleFormLabel label={'Comment'} sx={{ width: '25%', placeSelf: 'flex-start' }} />
            <Box sx={{ width: '75%' }}>
              {getFormFields(
                {
                  name: 'liquidityCapitalStructure.comments',
                  component: MULTI_LINE_INPUT,
                  label: 'Comment',
                },
                props.control,
                state.viewOnly
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
